import {
  AcademicCalendar,
  AuthorizationContextInput,
  CourseCalendar,
  IDSK,
} from "@examspark/types";

import { GraphQLAPI } from "../../client";

export const deleteAcademicCalendar = async (
  id: string,
  authorizationContext: AuthorizationContextInput,
) => {
  const results = await GraphQLAPI.client.query<{
    deleteAcademicCalendar: AcademicCalendar;
  }>({
    query: /* GraphQL */ `
      mutation DeleteAcademicCalendar(
        $input: DeleteAcademicCalendarInput!
        $authorizationContext: AuthorizationContextInput
      ) {
        deleteAcademicCalendar(
          input: $input
          authorizationContext: $authorizationContext
        ) {
          id
          sk
          workspaceId
          schemaVersion
          name
          __typename
        }
      }
    `,
    variables: {
      input: {
        id,
        sk: "academic-calendar#v0",
      },
      authorizationContext,
    },
  });

  return results.data?.deleteAcademicCalendar;
};

export const deleteCourseCalendar = async (
  key: IDSK,
  authorizationContext: AuthorizationContextInput,
) => {
  const results = await GraphQLAPI.client.query<{
    deleteCourseCalendar: CourseCalendar;
  }>({
    query: /* GraphQL */ `
      mutation DeleteCourseCalendar(
        $input: DeleteCourseCalendarInput!
        $authorizationContext: AuthorizationContextInput
      ) {
        deleteCourseCalendar(
          input: $input
          authorizationContext: $authorizationContext
        ) {
          id
          sk
          workspaceId
          schemaVersion
          name
          __typename
        }
      }
    `,
    variables: {
      input: key,
      authorizationContext,
    },
  });

  return results.data?.deleteCourseCalendar;
};
